import React from 'react';

import './App.css'

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Box } from '@mui/material';

import { Navbar, VideoDetail, ChannelDetail, SearchFeed } from './components';

import Feed from './components/Feed'

const App = () => (
    <BrowserRouter>
        <Box sx={{ backgroundColor: '#000' }}>
            <Navbar />
            <Routes>
                {/* <Route exact path='/feed' element={<Feed />} /> */}
                <Route path='/video/:id' element={<VideoDetail />} />
                <Route path='/channel/:id' element={<ChannelDetail />} />
                <Route path='/search/:searchTerm' element={<SearchFeed />} />
            </Routes>
            <Feed />
        </Box>
  </BrowserRouter>
  );

export default App